import { HaNCellSkeleton } from "../../HaNCellSkeleton";

const ROW_COUNT = 6;

// Rows shaped like the cells that will replace them. The map's loading pill already says what's loading, so these are
// only decoration.
export const HaNResultListLoading = () => {
  return (
    <ul
      aria-hidden
      className="flex flex-col gap-2 px-3 py-2">
      {Array.from({ length: ROW_COUNT }, (_, index) => (
        <li
          key={index}
          className="p-2">
          <HaNCellSkeleton />
        </li>
      ))}
    </ul>
  );
};
